export const buildLoads = (
    data: any,
    vehicleExternalParts: any[],
    vehicleInternalParts: any[]
    ) => {
      if (!data) return [];
      
      const containerLoads = (data.containers || []).map((c: any) => {
        const additionalSealNumbers = (c.additionalSealNumbers || [])
          .filter((sealNumber: any) => typeof sealNumber === "string")
          .map((sealNumber: string) => sealNumber.trim())
          .filter(Boolean);
      
        return {
          "@type": "ContainerLoad",
          reference: c.reference,
          loadFillingStatus: c.loadFillingStatus?.value,
      
          //...(c.sealNumber && {
            sealNumber: c.sealNumber,
          //}),

          // sealNumber: c.additionalSealNumbers[0]?.sealNumber,

          ...(additionalSealNumbers.length > 0 && {
            additionalSealNumbers,
          }),
      
          containerType: c.containerType?.value,
          tareWeight: c.tareWeight,
          netWeight: c.netWeight,
      
          ...(c.goodsDescription && {
            goodsDescription: c.goodsDescription,
          }),
        };
      });

    const bagLoads = (data.bags || []).map((b: any) => ({
      "@type": "BagLoad",
      content: b.content,
      designation: b.designation,
      brand: b.brand,
      packaging: b.packaging,
      tonnage: b.tonnage,
      batchNumber: b.batchNumber,
      unitWeight: b.unitWeight,
      qty:  Number(b.qty),
    }));
  
    const vehicleLoads = (data.vehicles || []).map((v: any) => ({
      "@type": "VehicleLoad",
      registrationNumber: v.registrationNumber,
      brand: v.brand,
      model: v.model,
      serialNumber: v.serialNumber,
      fuelType: v.fuelType,
      hasFuel: v.hasFuel,
      ...(v.hasFluel && {
        fuelLevel: v.fuelLevel
      }),
      operational: v.operational,
      length: v.length,
      width: v.width,
      height: v.height,
      tonnage: v.tonnage,
      vehicleInspectionItems: [
        ...vehicleExternalParts.map((item: any) => ({
          item: item["@id"],
          section: "/api/vehicle_sections/EXTERIOR",
          present: !!v?.vehicleInspectionItems?.EXTERIOR?.[item.id],
        })),
        ...vehicleInternalParts.map((item: any) => ({
          item: item["@id"],
          section: "/api/vehicle_sections/INTERIOR",
          present: !!v?.vehicleInspectionItems?.INTERIOR?.[item.id],
        })),
      ],
    }));
  
    const craftLoads = (data.crafts || []).map((cr: any) => ({
      "@type": "CraftLoad",
      name: cr.name,
      craftType: cr.craftType?.value,
      craftPosition: cr.craftPosition?.value,
      engineType: cr.engineType,
      className: cr.className,
      engineBrand: cr.engineBrand,
      length: cr.length,
      width: cr.width,
      height: cr.height,
      hasFuel: cr.hasFuel,
      observations: cr.observations,
      tonnage: cr.tonnage,
      
    }));
  
    const otherLoads = (data.others || []).map((o: any) => ({
      "@type": "OtherLoad",
      label: o.label,
      description: o.description,
      quantity: o.quantity,
      unit: o.unit,
      tonnage: o.tonnage,
    }));
  
    return [...containerLoads, ...bagLoads, ...vehicleLoads, ...craftLoads, ...otherLoads];
  };